import type { Glyph } from "./types";

export const ArrowDropDownIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M24.5 41L6.747 10.25L42.254 10.25L24.5 41Z" />
  </svg>
);

export default ArrowDropDownIcon;
